var data, prevData, height = 0, counter = 0, dataCount = 0;

$(document).ready(function(){

	if($('[data-component="highlights"]').length > 0){
		var highlights = new Highlights();
	}

	if($('[data-component="bank-features"]').length > 0){
		var bankFeatures = new BankFeatures();
	}

	if($('[data-component="highlight-carrousel"]').length > 0){
		var highlightCarrousel = new HighlightCarrousel();
	}

	if($('[data-component="news"]').length > 0){
		var news = new News();
	}

	if($('[data-component="how-to-invest"]').length > 0){
		var howToInvest = new HowToInvest();
	}

	if($('[data-component="article-slider"]').length > 0){
		var slider = new Slider();
	}

	if($('[data-component="gallery"]').length > 0){
		var gallery = new Gallery();
	}

	if($('[data-component="header"]').length > 0){
		var header = new Header();
	}

	if($('[data-component="subhead"]').length > 0){
		var subhead = new Subhead();
	}

	if($('[data-component="faq-item"]').length > 0){
		var faqItem = new FaqItem();
	}

	if($('[data-component="faq-options"]').length > 0){
		var faqOptions = new FaqOptions();
	}

	if ($('[data-component="video"]').length > 0){
		var video = new Video();
	}

	if($('[data-component="register"]').length > 0) {
		var register = new Register();
	}

	if($('[data-component="accounts"]').length > 0) {
		var accounts = new Accounts();
	}

	if($('[data-component="tabs"]').length > 0){
		var tabs = new Tabs();
	}

	if($('[data-component="tabs-commercial"]').length > 0){
		var tabsCommercial = new TabsCommercial();
	}

	if($('[data-component="table-modal"]').length > 0){
		var tableModal = new TableModal();
	}

	if($('[data-component="timeline"]').length > 0){
		var timeline = new Timeline();
	}

	if($('[data-component="main-search"]').length > 0){
		var mainSearch = new MainSearch();
	}

	if($('[data-component="states"]').length > 0){
		var offices = new Offices();
	}

	if($('[data-component="graphics"]').length > 0) {
		var graphics = new Graphics();
	}

	if($('[data-component="transitions"]').length > 0) {
		var transition = new Transition();
	}

	if($('[data-component="ranking"]').length > 0) {
		var ranking = new Ranking();
	}

	if($('[data-component="receive-email"]').length > 0) {
		var receiveEmail = new ReceiveEmail();
	}

	if($('[data-component="form"]').length > 0) {

		$('[data-component="form"]').each(function() {

			var $self = $(this).find('form');
			var form = new Form($self);

		});
	}

	if($('[data-component="message"]').length > 0) {

		$('[data-component="message"]').each(function() {

			var $self = $(this).find('form');
			var form = new Message($self);
		});
	}

	$('.back-top').on('click', function(e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: 0
		}, 700);

	});

	if ($('[data-equalizer]').length) {
		if ($(window).width() >= 768) {
			$('[data-equalizer]').each(function (e) {
				if($(this).find('[data-component="cities"]').length > 0) {
					if ($(window).width() > 1024) {
						data = $(this).attr('data-equalizer');
					if (counter < 1) {
						prevData = data;
						counter++;
					}
					if (data === prevData) {
						dataCount++;
						calculateHeight($(this), data);
					} else {
						counter = 0;
						height = 0;
						prevData = '';
						calculateHeight($(this), data);
					}
					if (dataCount === $('[data-equalizer="' + data + '"]').length) {
						$('[data-equalizer="' + data + '"] > div').height(height);
						// dataCount = 0;
					}
					}

				} else {
					data = $(this).attr('data-equalizer');
					if (counter < 1) {
						prevData = data;
						counter++;
					}
					if (data === prevData) {
						dataCount++;
						calculateHeight($(this), data);
					} else {
						counter = 0;
						height = 0;
						prevData = '';
						calculateHeight($(this), data);
					}
					if (dataCount === $('[data-equalizer="' + data + '"]').length) {
						$('[data-equalizer="' + data + '"] > div').height(height);
						// dataCount = 0;
					}
				}
			});
		}
	}

	$('img.svg').each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.get(imgURL, function (data) {
			// Get the SVG tag, ignore the rest
			var $svg = $(data).find('svg');

			// Add replaced image's ID to the new SVG
			if (typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}
			// Add replaced image's classes to the new SVG
			if (typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass + ' replaced-svg');
			}

			// Remove any invalid XML tags as per http://validator.w3.org
			$svg = $svg.removeAttr('xmlns:a');

			// Check if the viewport is set, else we gonna set it if we can.
			if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
				$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
			}

			// Replace image with new SVG
			$img.replaceWith($svg);

		}, 'xml');

	});

	$('.phone').mask('(00) 00000-0000');
	$('.date').mask('00/00/0000');

	$('span.Botao').each(function() {
		$(this).find('a').append('<i class="icon-arrow-right-white"></i>');
	});


});

function calculateHeight(item, data) {

	if (item.height() > height) {
		height = item.outerHeight();
	}
}
